import React from 'react';

const PhoneOtpForm = ({
  logoSrc,
  headingLines,        // array of strings, e.g. ["Supervisor Login", "Welcome to Factrika On-Demand"]
  showOtp,
  phone,
  onPhoneChange,
  onPhoneKeyPress,
  acceptedWhatsApp,
  acceptedTerms,
  onAcceptedTermsChange,
  otp,
  onOtpChange,
  onOtpKeyPress,
  onSendOtp,
  onVerifyOtp,
  loading,
}) => {
  return (
    <div className="min-h-screen overflow-y-auto py-16 flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full space-y-8 p-8 bg-white rounded-xl shadow-lg">
        <div className="text-center flex flex-col items-center justify-center">
          <img
            src={logoSrc}
            alt="FactoryKaOnDemand"
            width={180}
            height={180}
            className="object-contain"
          />
          {headingLines.map((line, i) => (
            <h2
              key={i}
              className="mt-6 text-sm sm:text-base md:text-xl lg:text-2xl font-black text-gray-900 whitespace-nowrap px-2"
            >
              {line}
            </h2>
          ))}
        </div>

        <div className="mt-8 space-y-6">
          {!showOtp ? (
            <div>
              <input
                type="tel"
                maxLength={10}
                value={phone}
                onChange={onPhoneChange}
                onKeyPress={onPhoneKeyPress}
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
                placeholder="Enter phone number"
              />

              <div className="mb-3 mt-6">
                <label className="flex items-start">
                  <input
                    type="checkbox"
                    checked={acceptedWhatsApp}
                    onChange={() => {}}
                    disabled
                    className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 mt-1 mr-2 bg-gray-100 cursor-not-allowed"
                  />
                  <span className="text-sm text-gray-600">
                    I allow Factrika to send me WhatsApp messages and updates.
                  </span>
                </label>
              </div>

              <div className="mb-3 mt-6">
                <label className="flex items-start">
                  <input
                    type="checkbox"
                    checked={acceptedTerms}
                    onChange={onAcceptedTermsChange}
                    className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 mt-1 mr-2"
                  />
                  <span className="text-sm text-gray-600">
                    I accept the Terms and Conditions &amp; &nbsp;
                    <a
                      href="https://factrika.com/privacy-policy/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-indigo-600 hover:text-indigo-700 underline"
                    >
                      Privacy Policy
                    </a>
                  </span>
                </label>
              </div>

              <button
                onClick={onSendOtp}
                disabled={phone.length !== 10 || loading || !acceptedTerms}
                className="mt-4 w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50"
              >
                Send OTP
              </button>
            </div>
          ) : (
            <div>
              <input
                type="text"
                maxLength={6}
                value={otp}
                onChange={onOtpChange}
                onKeyPress={onOtpKeyPress}
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
                placeholder="Enter OTP"
              />
              <button
                onClick={onVerifyOtp}
                disabled={otp.length !== 4 || loading}
                className="mt-4 w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50"
              >
                Verify OTP
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PhoneOtpForm;